import { render, staticRenderFns } from "./TargetsCRM.vue?vue&type=template&id=6aa4a880&scoped=true"
import script from "./TargetsCRM.vue?vue&type=script&lang=js"
export * from "./TargetsCRM.vue?vue&type=script&lang=js"
import style0 from "./TargetsCRM.vue?vue&type=style&index=0&id=6aa4a880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4a880",
  null
  
)

export default component.exports